import React, { useRef, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Grid,
  Box,
  Divider,
  Avatar,
  Stack,
  Button,
  Badge,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import capitalizeFirstLetter from "utils/capitalizeFirstLetter";
import API from "api/API";
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from "providers/AuthContextProvider";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CardexDialog from "components/CardexDialog";
import { isValidCurp } from "utils/isValidCurp";

const Cardex= () => {
  const { user } = useAuth();
  const {state} = useLocation()
  const fileInputRef = useRef();
  const cardexRef = useRef();
  const [loading, setLoading] = useState(false)
  const [snackbarState, setSnackbarState] = React.useState({open: false, message: "", status: "info"});
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [gender, setGender] = useState(state?.gender ?? null);
  const [secure, setSecure] = useState(state?.secure ?? null);
  const [civilState, setCivilState] = useState(null);
  const [address1, setAddress1] = useState(null)
  const [selectedStd, setSelectedStd] = React.useState(state?.sexually_transmitted_disease ?? []);
  const [selectedCdd, setSelectedSdd] = React.useState(state?.chronic_degenerative_diseases ?? []);
  const [selectedSports, setSelectedSports] = React.useState(state?.sport ?? []);
  const [selectedDrugAllergies, setSelectedDrugAllergies] = React.useState(state?.drug_allergy ?? []);
  const [selectedAllergies, setSelectedAllergies] = React.useState(state?.common_allergies ?? []);
  const [selectedDisabilities, setSelectedDisabilities] = React.useState(state?.disabilities ?? []);
  const [selectedBlood, setSelectedBlood] = React.useState(state?.blood_type?.toUpperCase());
  const [contacts, setContacts] = useState(state?.emergency_contacts ?? [ { name: "", relationship: "", phone: "" }]);
  const [columns,setColumns] = React.useState(
    [
      { 
        id: 'name', 
        label: 'Nombre', 
        defaultValue: state.name,
        required: true,
        type:"text",
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
      },
      { 
        id: 'last_name', 
        label: 'Apellido paterno', 
        defaultValue: state.last_name,
        required: true,
        type:"text",
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
      },
      {
        id: 'maternal_surname',
        label: 'Apellido materno',
        defaultValue: state.maternal_surname,
        type:'text',
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
      },
      {
        id: 'birth_date',
        label: 'Fecha de nacimiento',
        defaultValue: state.birth_date,
        required: true,
        type:'date',
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
      },
      {
        id: 'telephone',
        label: 'Telefono de contacto',
        defaultValue: state.telephone,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
      },
      {
        id: 'gender',
        label: 'Genero',
        defaultValue: state.gender,
        required: true,
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
        options:['Masculino', 'Femenino']
      },
      {
        id: 'secure',
        label: 'Seguro medico',
        defaultValue: state.secure,
        required: true,
        disabled:false,
        xs:12, 
        sm:6, 
        md:6,
        lg:6,
        xl:6,
        options:['IMSS', 'ISSTE', 'Privado', 'Ninguno']
      },
      {
        id: 'secureNumber',
        label: 'Numero de seguro',
        defaultValue: state?.secureNumber,
        required: true,
        disabled:false,
        xs:12, 
        sm:6, 
        md:6,
        lg:6,
        xl:6,
      },
      {
        id: 'sexually_transmitted_disease',
        label: 'Enfermedades de transmicion sexual',
        defaultValue: state.sexually_transmitted_disease,
        required: true,
        disabled:false,
        xs:12, 
        sm:6, 
        md:6,
        lg:6,
        xl:6,
        options: ['Ninguna', 'VIH/SIDA', 'Sífilis', 'Gonorrea', 'Clamidia', 'Herpes genital', 'Virus del Papiloma Humano (VPH)', 'Tricomoniasis', 'Hepatitis B', 'Hepatitis C', 'Linfogranuloma venéreo (LGV)', 'Chancro blando', 'Granuloma inguinal', 'Molusco contagioso', 'Uretritis no gonocócica', 'Vaginosis bacteriana', 'Otros']
      },
      {
        id: 'chronic_degenerative_diseases',
        label: 'Enfermedades generativas cronicas',
        defaultValue: state.chronic_degenerative_diseases,
        required: true,
        disabled:false,
        xs:12, 
        sm:6, 
        md:6,
        lg:6,
        xl:6,
        options:['Ninguna', 'Diabetes mellitus tipo 2', 'Hipertensión arterial', 'Enfermedad renal crónica', 'Enfermedades cardiovasculares', 'Cáncer (mama, próstata, cervicouterino, pulmón, colon)', 'Obesidad y sobrepeso', 'Enfermedad pulmonar obstructiva crónica (EPOC)', 'Artritis reumatoide', 'Osteoartritis', 'Asma crónica', 'Demencias (como Alzheimer)']
      },
      {
        id: 'sport',
        label: 'Pratica algun deporte',
        defaultValue: state.sport,
        required: true,
        disabled:false,
        xs:12, 
        sm:5, 
        md:5,
        lg:5,
        xl:5,
        options: ['Ninguno', 'Fútbol', 'Básquetbol', 'Béisbol', 'Boxeo', 'Lucha libre', 'Natación', 'Atletismo', 'Ciclismo', 'Voleibol', 'Tenis', 'Frontón', 'Taekwondo', 'Gimnasia', 'Karate', 'Skateboarding', 'Charrería', 'Artes marciales mixtas (MMA)', 'Senderismo', 'Escalada', 'Golf']
      },
      {
        id: 'otherSport',
        label: 'Otro (escribelo)',
        defaultValue: state.otherSport,
        required: false,
        disabled:false,
        xs:12, 
        sm:5, 
        md:5,
        lg:5,
        xl:5,
      },
      {
        id: 'age',
        label: 'Edad',
        defaultValue: state.age,
        required: true,
        type:'number',
        disabled:false,
        xs:12, 
        sm:2, 
        md:2,
        lg:2,
        xl:2,
      },
      {
        id: 'weight',
        label: 'Peso en KG',
        defaultValue: state.weight,
        required: true,
        type:'number',
        disabled:false,
        xs:12, 
        sm:2, 
        md:2,
        lg:2,
        xl:2,
      },
      {
        id: 'height',
        label: 'Altura en CM',
        defaultValue: state.height,
        required: true,
        type:'number',
        disabled:false,
        xs:12, 
        sm:3, 
        md:3,
        lg:3,
        xl:3,
      },
      {
        id: 'cellphone',
        label: 'Celular',
        defaultValue: state.cellphone,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:3, 
        md:3,
        lg:3,
        xl:3,
      },
      {
        id: 'curp',
        label: 'CURP',
        defaultValue: state.curp,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
      },
      {
        id: 'civil_state',
        label: 'Estado civil',
        defaultValue: state.civil_state,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
        options:['Soltero/a', 'Casado/a', 'Unión libre', 'Divorciado/a', 'Viudo/a', 'Separado/a']
      },
      {
        id: 'drug_allergy',
        label: 'Alergia a farmacos',
        defaultValue: state.drug_allergy,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
        options: ['Ninguna', 'Penicilina', 'Amoxicilina', 'Cefalosporinas', 'Sulfonamidas', 'Aspirina (ácido acetilsalicílico)', 'Ibuprofeno', 'Paracetamol', 'Antiinflamatorios no esteroides (AINEs)', 'Anestésicos locales (como lidocaína)', 'Anticonvulsivos (como fenitoína o carbamazepina)', 'Contrastes yodados', 'Vacunas', 'Otros']
      },
      {
        id: 'common_allergies',
        label: 'Alergias',
        defaultValue: state.common_allergies,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
        options: ['Ninguna', 'Polen', 'Ácaros del polvo', 'Polvo', 'Caspa de perro', 'Caspa de gato', 'Picadura de abeja', 'Lácteos', 'Gluten', 'Mariscos', 'Cacahuates', 'Nueces', 'Frutas (como plátano o fresa)', 'Moho', 'Medicamentos', 'Látex', 'Otros']
      },
      {
        id: 'disabilities',
        label: 'Discapacidades',
        defaultValue: state.disabilities,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
        options:['Ninguna', 'Discapacidad visual', 'Discapacidad auditiva', 'Discapacidad motriz', 'Discapacidad intelectual', 'Discapacidad psicosocial (mental)', 'Discapacidad del habla o lenguaje', 'Discapacidad múltiple', 'Autismo o espectro autista', 'Síndrome de Down', 'Parálisis cerebral', 'Otros']
      },
      {
        id: 'blood_type',
        label: 'Tipo de sangre',
        defaultValue: state.blood_type,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:3, 
        md:3,
        lg:3,
        xl:3,
        options:['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'],
      },
      {
        id: 'address_1',
        label: 'Direccion por codigo postal',
        defaultValue: state.address_1,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:4, 
        md:4,
        lg:4,
        xl:4,
      },
      {
        id: 'address_2',
        label: 'Calle y numero',
        defaultValue: state.address_2,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:8, 
        md:8,
        lg:8,
        xl:8,
      },
      {
        id: 'emergency_contacts',
        label: 'Contactos de emergencia',
        defaultValue: state.emergency_contacts,
        required: false,
        type:'text',
        disabled:false,
        xs:12, 
        sm:12, 
        md:12,
        lg:12,
        xl:12,
      },
    ]
  );

  const handleCloseDialog = () => {
          setOpenDialog(false);
  };
  const handleChangeStd= (event) => {
      const {
      target: { value },
      } = event;
      setSelectedStd(typeof value === 'string' ? value.split(',') : value);
  };
  const handleChangeCdd= (event) => {
      const {
      target: { value },
      } = event;
      setSelectedSdd(typeof value === 'string' ? value.split(',') : value);
  };
  const handleChangeSports= (event) => {
      const {
      target: { value },
      } = event;
      setSelectedSports(typeof value === 'string' ? value.split(',') : value);
  };
  const handleChangeDrugAllergies= (event) => {
      const {
      target: { value },
      } = event;
      setSelectedDrugAllergies(typeof value === 'string' ? value.split(',') : value);
  };
  const handleChangeAllergies = (event) => {
      const {
      target: { value },
      } = event;
      setSelectedAllergies(typeof value === 'string' ? value.split(',') : value);
  };
  const handleChangeDisabilities = (event) => {
      const {
      target: { value },
      } = event;
      setSelectedDisabilities(typeof value === 'string' ? value.split(',') : value);
  };
  const handleChangeSecure = (event)=>{
      setSecure(event.target.value)
  }
  const handleChangeGender = (event)=>{
      setGender(event.target.value)
  }
  const handleChangeBlood = (event)=>{
      setSelectedBlood(event.target.value)
  }
  const handleChangeCivilState = (event)=>{
      setCivilState(event.target.value)
  }
  const handleSubmit = async (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);

      
      // 1. Declarar variables del formulario
      const name = data.get('name');
      const lastName = data.get('last_name');
      const maternalSurname = data.get('maternal_surname');
      const birthDate = data.get('birth_date');
      const telephone = data.get('telephone');
      const cellphone = data.get('cellphone');
      const otherSport = data.get('otherSport');
      const secureNumber = data.get('secureNumber');
      const age = data.get('age');
      const weight = data.get('weight');
      const height = data.get('height');
      const curp = data.get('curp');
      const address2 = data.get('address_2');
      //const emergencyContacts = data.get('emergency_contacts');


      console.log(name)
      console.log(lastName)
      console.log(birthDate)


      // 2. Validaciones básicas
      if (!isValidCurp(curp)) {
          setSnackbarState({
              open: true,
              message: "Proporciona un CURP válido",
              status: "warning",
          });
          return;
      }

      if (!name || !lastName || !birthDate) {
          setSnackbarState({
              open: true,
              message: "Nombre, apellido y fecha de nacimiento son obligatorios",
              status: "warning",
          });
          return;
      }
      console.log(data)

      // 3. Construir el requestBody
      const requestBody = {
          id: state.id,
          user_id: user.id,
          name: name,
          last_name: lastName,
          maternal_surname: maternalSurname,
          birth_date: birthDate,
          telephone: telephone,
          cellphone: cellphone,
          gender: gender,
          secureNumber: secureNumber,
          secure: secure,
          sexually_transmitted_disease: selectedStd,
          chronic_degenerative_diseases: selectedCdd,
          sport: selectedSports,
          otherSport: otherSport,
          age: Number(age),
          weight: Number(weight),
          height: parseFloat(height),
          curp: curp,
          civil_state: civilState,
          drug_allergy: selectedDrugAllergies,
          common_allergies: selectedAllergies,
          disabilities: selectedDisabilities,
          blood_type: selectedBlood,
          medical_history: null,
          address: address2+' '+address1,
          emergency_contacts: contacts,
      };

      // 4. Enviar petición
      setLoading(true)
      const response = await API.patchCardex(requestBody);
      setLoading(false)

      if (response.status === 200) {
          setSnackbarState({
              open: true,
              message: response.message,
              status: "success",
          });
          handleCloseDialog(); 
      } else {
          setSnackbarState({
              open: true,
              message: response.message || "Error inesperado",
              status: "error",
          });
      }

  };

  const renderChips = (items) =>
  Array.isArray(items)
    ? items.map((item, i) => (
        <Chip key={i} label={item} variant="outlined" size="small" sx={{ m: 0.5 }} />
      ))
    : null;


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Mostrar preview
    const previewURL = URL.createObjectURL(file);
    setAvatarPreview(previewURL);

    // Subir imagen
    const response = await API.postMedia(file, { folder: "users", filename: state.id });

    if (response.status === 200) {
      console.log("✅ Imagen subida correctamente:", response.data);
      const url  = response.data.url
      const requestBody = state
      requestBody.image_url = url
      const responsePatchSon = await API.patchSon(requestBody)
      if (responsePatchSon.status === 200) {
        console.log("✅ Información actualizada correctamente:", responsePatchSon.data);
      } else {
        console.error("❌ Error al actualizar información:", responsePatchSon.message);
      }
    } else {
      console.error("❌ Error al subir imagen:", response.message);
    }
  };

  const handleExportPDF = async () => {
    const input = cardexRef.current;
    if (!input) return;

    // Captura de pantalla del componente
    const canvas = await html2canvas(input);
    const imgData = canvas.toDataURL("image/png");

    // Crea PDF
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pageWidth;
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("cardex.pdf");
  };

  const handleEdit = async()=>{
    setOpenDialog(true)
  }

  const handleCloseSnackBar = (event, reason) => {
      if (reason === 'clickaway') {
          return;
      }
      setSnackbarState({open:false,message:snackbarState.message,status:snackbarState.status})
  };

  return (
    <>
      <Card sx={{ maxWidth: "100%", px: 2, m: 2, borderRadius: 3, boxShadow: 3 }}>
        <CardContent>
          <Badge overlap="circular"  sx={{m:2}} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              badgeContent={
              <IconButton
                  size="small"
                  color="primary"
                  sx={{
                      bgcolor: 'background.paper',
                      boxShadow: 1,
                      '&:hover': { bgcolor: 'grey.200' },
                      width: 28,
                      height: 28,
                      p: 0,
                  }}
                  onClick={() => fileInputRef.current.click()}
              >
                  <EditIcon fontSize="small" />
              </IconButton>
              }
          >
              <input
                  type="file"
                  accept="image/*"
                  capture="environment"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleFileChange}
              />
              <Avatar
                  alt={state.name}
                  src={avatarPreview || state.image_url}
                
                  sx={{ cursor: "pointer", width: 100, height: 100}}
              />
          </Badge>
          <div ref={cardexRef}>
            <Box sx={{ my: 2, p:2 }} >
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                {capitalizeFirstLetter(state.name)} {capitalizeFirstLetter(state.last_name)} {capitalizeFirstLetter(state.maternal_surname)}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                CURP: {state.curp.toUpperCase()}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                Edad: {state.age} 
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                Género: {state.gender}
              </Typography>
              {/*<Typography variant="body2">Tipo: {state.type}</Typography>*/}
              <Divider sx={{ my: 2 }} />

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2">Enfermedades de Transmisión Sexual:</Typography>
                  <Box>{renderChips(state.sexually_transmitted_disease)}</Box>

                  <Typography variant="subtitle2" sx={{ mt: 1 }}>
                    Enfermedades Crónicas:
                  </Typography>
                  <Box>{renderChips(state.chronic_degenerative_diseases)}</Box>

                  <Typography variant="subtitle2" sx={{ mt: 1 }}>
                    Deportes:
                  </Typography>
                  <Box>{renderChips(state.sport)}</Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2">Alergias a medicamentos:</Typography>
                  <Box>{renderChips(state.drug_allergy)}</Box>

                  <Typography variant="subtitle2" sx={{ mt: 1 }}>
                    Alergias comunes:
                  </Typography>
                  <Box>{renderChips(state.common_allergies)}</Box>

                  <Typography variant="subtitle2" sx={{ mt: 1 }}>
                    Discapacidades:
                  </Typography>
                  <Box>{renderChips(state.disabilities)}</Box>
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />
              <Typography variant="body2">
                Peso: {state.weight}kg | Altura: {state.height}cm | Tipo de sangre: {state.blood_type}
              </Typography>
              <Typography variant="body2">Estado civil: {state.civil_state}</Typography>
              <Typography variant="body2">Teléfono: {state.telephone}</Typography>
              <Typography variant="body2">Celular: {state.cellphone}</Typography>
              <Typography variant="body2">Dirección: {state.address}</Typography>
            </Box>
          </div>
          <Stack spacing={1} direction={'row'} sx={{m:2}}>
            <Button variant="contained" onClick={handleExportPDF}>Exportar PDF</Button>
            <Button variant="contained" onClick={handleEdit}>Editar</Button>
          </Stack>
        </CardContent>
      </Card>
      <CardexDialog
        open={openDialog}
        onClose={handleCloseDialog}
        onSubmit={handleSubmit}
        loading={loading}
        title="Editar tutorado"
        columns={columns}
        extraProps={{
            gender: { value: gender, onChange: handleChangeGender },
            secure: { value: secure, onChange: handleChangeSecure },
            sexually_transmitted_disease: { value: selectedStd, onChange: handleChangeStd },
            chronic_degenerative_diseases: { value: selectedCdd, onChange: handleChangeCdd },
            sport: { value: selectedSports, onChange: handleChangeSports },
            civil_state: { value: civilState, onChange: handleChangeCivilState },
            drug_allergy: { value: selectedDrugAllergies, onChange: handleChangeDrugAllergies },
            common_allergies: { value: selectedAllergies, onChange: handleChangeAllergies },
            disabilities: { value: selectedDisabilities, onChange: handleChangeDisabilities },
            blood_type: { value: selectedBlood, onChange: handleChangeBlood },
            setAddress1,
            contacts,
            setContacts,
        }}
      />
      <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbarState.open} onClose={handleCloseSnackBar}>
        <Alert
            onClose={handleCloseSnackBar}
            severity={snackbarState.status}
            variant="filled"
        >
            {snackbarState.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Cardex;
